import React from "react";
import { STATUS_LABEL, STATUS_CLASS } from "../../lib/adminUtils";

export const Badge = ({ status }) => (
  <span
    className={`inline-block text-[10px] uppercase tracking-wider font-bold px-2 py-1 rounded ${
      STATUS_CLASS[status] || "bg-slate-200 text-slate-700"
    }`}
    data-testid={`badge-${status}`}
  >
    {STATUS_LABEL[status] || status}
  </span>
);

export const Card = ({ title, value, hint, accent, testid }) => (
  <div
    className="bg-white border border-slate-200 rounded-md p-5"
    data-testid={testid}
  >
    <p className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">
      {title}
    </p>
    <p
      className={`mt-1 font-display font-black text-3xl ${
        accent ? "text-[#016C36]" : "text-slate-900"
      }`}
    >
      {value}
    </p>
    {hint && <p className="text-xs text-slate-500 mt-1">{hint}</p>}
  </div>
);

export const Empty = ({ label }) => (
  <div className="bg-white border border-dashed border-slate-300 rounded-md p-10 text-center text-sm text-slate-500">
    {label}
  </div>
);

export const SectionTitle = ({ children, action }) => (
  <div className="flex items-center justify-between mb-3">
    <h3 className="font-display font-bold text-base text-slate-900">{children}</h3>
    {action}
  </div>
);

export const Table = ({ headers, children, testid }) => (
  <div className="bg-white border border-slate-200 rounded-md overflow-hidden" data-testid={testid}>
    <table className="w-full text-sm">
      <thead className="bg-slate-50">
        <tr>
          {headers.map((h, i) => (
            <th
              key={i}
              className="text-left text-[10px] uppercase tracking-wider text-slate-500 font-semibold p-3"
            >
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  </div>
);

export const Field = ({ label, children, hint }) => (
  <label className="block text-sm">
    <span className="block text-[10px] uppercase tracking-wider text-slate-500 font-semibold mb-1">
      {label}
    </span>
    {children}
    {hint && <span className="block text-xs text-slate-400 mt-1">{hint}</span>}
  </label>
);

export const Info = ({ label, value }) => (
  <div>
    <p className="text-[10px] uppercase tracking-wider text-slate-400 font-semibold">
      {label}
    </p>
    <p className="text-sm text-slate-800 break-words">{value || "—"}</p>
  </div>
);
